<mat-card id="viewLandScape" fxLayout="row" fxLayoutAlign="space-around center" *ngIf="!diviceXs && !diviceSm">

    <!-- <a [routerLink]="[{ outlets: { primary: ['product', product.id], sidebar: ['product', product.id]}}]"  routerLinkActive="active">{{product.id}}</a> -->

    <div id="img" fxFlex="20" (click)="goToProductView(product.id)">
        <img *ngIf="product.mainPhoto !=  undefined" mat-card-image src="{{product.mainPhoto}}" [alt]="product.name">
        <img *ngIf="product.mainPhoto === undefined" mat-card-image src="../../../../assets/img/caja.jpg " [alt]="product.name">
    </div>


    <mat-card-content fxLayout.xs="column" fxLayout.sm="column" fxLayout="row" fxLayoutAlign="space-around center" fxFlex="80">
        <div class="contentOne" fxFlex="70" (click)="goToProductView(product.id)">
            <h3>{{product.brand}}</h3>
            <h1>{{product.name}}</h1>
            <h3>{{product.reference}}</h3>
            <p>{{product.description}}</p>
        </div>

        <div class="contentTwo" fxFlex="30">
            <div id="price">
                <h2>Precio</h2>
                <p>{{product.price | currency:'COP '}}</p>
                <p id="gessiRevenue">Acumula: {{product.pointsRevenue}} Gessis</p>
            </div>

            <div id="gessiPoints">

                <h2>Gessis</h2>

                <div fxLayout="row" fxLayoutAlign="end center">
                    <p>{{product.points}}</p>

                    <div id="btn-actInfoGessiPoints" (mouseover)="infoGessiPoints=true" (mouseout)="infoGessiPoints=false">
                        <span class="material-icons">help_outline</span>
                    </div>
                </div>


                <div id="infoGessiPoints" [hidden]="!infoGessiPoints">

                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
                </div>
            </div>

            <button mat-raised-button type="button" (click)="addToCar(product)">¡Lo quiero!</button>
        </div>

    </mat-card-content>

</mat-card>

<mat-card id="cellPhone" fxLayout="column" fxLayoutAlign="none center" *ngIf="diviceXs || diviceSm">

    <div id="contenFlexRow" fxLayout="row" fxLayoutAlign="space-between center" (click)="goToProductView(product.id)">
        <div id="img" fxFlex="30">
            <img *ngIf="product.mainPhoto !=  undefined" mat-card-image src="{{product.mainPhoto}}" [alt]="product.name">
            <img *ngIf="product.mainPhoto === undefined" mat-card-image src="../../../../assets/img/caja.jpg " [alt]="product.name">
        </div>

        <div class="contentOne" fxFlex="65" fxLayout="column">
            <h3>{{product.brand}}</h3>
            <h1>{{product.name}}</h1>

            <div class="contentCost">
                <div id="price" class="priceCostAndPoints" fxLayout="row" fxLayoutAlign="start center">
                    <h2>Precio</h2>
                    <p>{{product.price | currency:'COP '}}</p>
                </div>

                <div id="gessiPoints" class="priceCostAndPoints" fxLayout="row" fxLayoutAlign="start center">
                    <h2>Gessis</h2>
                    <p>{{product.points}}</p>

                    <div id="btn-actInfoGessiPoints" (mouseover)="infoGessiPoints=true" (mouseout)="infoGessiPoints=false">
                        <span class="material-icons">help_outline</span>
                    </div>

                    <div id="infoGessiPoints" [hidden]="!infoGessiPoints">

                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
                    </div>
                </div>
            </div>

        </div>

    </div>

    <div id="contentFlexColumn">
        <p>{{product.description}}</p>
        <button mat-raised-button type="button" (click)="addToCar(product)">¡Lo quiero!</button>
    </div>

</mat-card>